import React from 'react';
import { useMutation } from 'react-query';
import { brokerApi } from 'services/apis';
import { BrokerForm } from '../broker-form';
import { CreateBrokerPayloadDto } from 'libs/pinnacle-sdk';

const CreateBrokerForm: React.FC = () => {
  const createBrokerMutation = useMutation<
    void,
    Error,
    { broker: CreateBrokerPayloadDto; fileIds: string[] }
  >(async ({ broker, fileIds }) => {
    await brokerApi.createBroker({
      createBrokerPayloadDto: {
        ...broker,
        fileIds,
      },
    });
  });

  return (
    <BrokerForm
      mode="create"
      onSubmit={createBrokerMutation.mutateAsync}
      isLoading={createBrokerMutation.isLoading}
    />
  );
};

export default CreateBrokerForm;
